<template>
  <div class="container-table-servs">
    <q-card>
      <q-card-section>
        <q-table
          :data="data"
          :columns="columns"
          row-key="id"
          selection="multiple"
          :filter="filter"
          :pagination.sync="pagination"
          data-cy="list-aplicaciones"
        >
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:top-right>
            <div>
              <q-input
                dense
                debounce="100"
                v-model="filter"
                outlined
                stack-label
                placeholder="Escriba para buscar"
              >
                <template v-slot:append>
                  <q-icon name="search" />
                </template>
              </q-input>
            </div>
          </template>
          <template v-slot:body="props">
            <q-tr
              :props="props"
              @click="triggerEdit(props.row)"
              style="cursor: pointer"
            >
              <q-td key="name" :props="props">
                {{ props.row.name }}
              </q-td>
              <q-td key="url" :props="props">
                {{ props.row.url }}
              </q-td>
              <q-td key="servCount" :props="props">
                {{ props.row.servicios.length }}
              </q-td>
              <q-td key="conectada" :props="props">
                <q-toggle
                  color="primary"
                  v-model="props.row.conectada"
                  @input="saveValue(props.row.conectada, props.row)"
                  disable
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </q-card-section>
    </q-card>
    <q-page-sticky position="bottom-right" :offset="[28, 28]">
      <q-btn
        data-cy="new-aplicacion"
        fab
        icon="add"
        title="Crear nueva aplicación"
        color="primary"
        @click="_createAplicacion()"
      />
    </q-page-sticky>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import Formats from '@/components/shared/mixins/Formats.js';

import {
  QTable,
  QTd,
  QTr,
  QTh,
  QCard,
  QCardSection,
  QPageSticky,
  QToggle
} from 'quasar';

export default {
  components: {
    QTable,
    QTd,
    QTr,
    QTh,
    QCard,
    QCardSection,
    QPageSticky,
    QToggle
  },
  mixins: [Message, Formats],
  props: {
    arrayAplicaciones: Array
  },
  computed: {},
  data () {
    return {
      pagination: {
        sortBy: 'displayOrder',
        descending: true,
        rowsPerPage: 20
      },
      data: this.arrayAplicaciones,
      columns: [
        {
          name: 'name',
          label: 'Nombre',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'url',
          label: 'URL',
          align: 'left',
          field: 'url',
          sortable: true
        },
        {
          name: 'servCount',
          label: 'Servicios',
          align: 'center',
          field: (row) => (row.servs == null ? 0 : row.servs.length), // TODO A la espera de Refactor Aplicaciones
          sortable: true
        },
        {
          name: 'conectada',
          label: 'Conectada',
          align: 'center',
          field: 'conectada',
          sortable: true
        }
      ],
      filter: ''
    };
  },
  methods: {
    triggerEdit (row) {
      this.$router.push({ name: 'form_application', params: { idApp: row.id } });
    },
    _createAplicacion () {
      this.$router.push({ name: 'form_new_app' });
    }
  },
  watch: {
    arrayAplicaciones: {
      handler: function () {
        this.data = this.arrayAplicaciones;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-table-servs {
  &:deep() {
    .q-table__card {
      box-shadow: none;
    }

    .q-card__section--vert {
      padding: 0 !important;
    }
  }
}
</style>
